// extracted by mini-css-extract-plugin
export default {"root":"IconPartner_root__Sk4iK"};